import React from 'react'
import { 
    EyeOutlined, 
    EditOutlined,  
    PlusOutlined, 
    CopyOutlined, 
    ClearOutlined, 
    SearchOutlined, 
    ReloadOutlined, 
    AccountBookOutlined, 
    FileTextOutlined, 
    ArrowUpOutlined, 
    CloseOutlined, 
    RollbackOutlined, 
    SaveOutlined,
    ClockCircleOutlined,
    EyeInvisibleOutlined,
    CheckOutlined,
    ExclamationCircleOutlined,
    UploadOutlined,
} from '@ant-design/icons';
import { Tooltip, Button } from 'antd';
function Icon(props) {    
    let icon = null;
    switch (props.type) {
        case 'add':
            icon = (
                <Tooltip title={props.title || '新增'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<PlusOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>新增</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'addMulti':
            icon = (
                <Tooltip title={props.title || '批量新增'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<PlusOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>批量新增</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'addIcon':
            icon = (
                <Tooltip title={props.title || '新增'} color='blue'>
                    <a onClick={props.onClick}>
                    <Button icon={<PlusOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}></Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'check':
            icon = (
                <Tooltip title={props.title || '查看'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<EyeOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>查看</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'checkIcon':
            icon = (
                <Tooltip title={props.title || '查看'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<EyeOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}></Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'edit':
            icon = (
                <Tooltip title={props.title || '修改'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<EditOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>修改</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'delete':
            icon = (
                <Tooltip title={props.title || '删除'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<CloseOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>删除</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'deleteAll':
            icon = (
                <Tooltip title={props.title || '删除全部'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<ClearOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>删除全部</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'copy':
            icon = (
                <Tooltip title={props.title || '复制新增'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<CopyOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>复制新增</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'search':
            icon = (
                <Tooltip title={props.title || '查询'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<SearchOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>查询</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'reset':
            icon = (
                <Tooltip title={props.title || '重置'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<ReloadOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>重置</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'bank':
            icon = (
                <Tooltip title={props.title || '银行账户'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<AccountBookOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>银行账户</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'invoice':
            icon = (
                <Tooltip title={props.title || '发票抬头'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<FileTextOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>发票抬头</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'submit':
            icon = (
                <Tooltip title={props.title || '提交'} color='blue'>
                    <a onClick={props.onClick}>
                    <Button icon={<ArrowUpOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>提交</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'withdraw':
            icon = (
                <Tooltip title={props.title || '取消提交'} color='blue'>
                    <a onClick={props.onClick}>
                        <Button icon={<RollbackOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>取消提交</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'pendding':
            icon = (
                <Tooltip title={props.title || '待提交'} color='blue'>
                    <a onClick={props.onClick}>
                                <Button icon={<ClockCircleOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>待提交</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'submitted':
            icon = (
                <Tooltip title={props.title || '已提交'} color='blue'>
                    <a onClick={props.onClick} >
                        <Button icon={<ArrowUpOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>已提交</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'save':
            icon = (
                <Tooltip title={props.title || '保存'} color='blue'>
                    <a onClick={props.onClick} >
                        <Button icon={<SaveOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}}>保存</Button>
                    </a>
                </Tooltip>
            )
            break;
        case 'needRead':
            icon = (
                <Tooltip title={props.title || '待阅读'} color='blue'>
                    <a onClick={props.onClick}>
                        <EyeInvisibleOutlined style={{color: '#1890ff',fontSize:'13px'}} />
                    </a>
                </Tooltip>
            )
            break;
        case 'readed':
            icon = (
                <Tooltip title={props.title || '已阅读'} color='blue'>
                    <a onClick={props.onClick}>
                    <EyeOutlined style={{color: '#1890ff',fontSize:'13px'}} />
                    </a>
                </Tooltip>
            )
            break;
        case 'needSubmit':
            icon = (
                <Tooltip title={props.title || '待提交'} color='blue'>
                    <a onClick={props.onClick}>
                        <EditOutlined style={{color: '#1890ff',fontSize:'13px'}} />
                    </a>
                </Tooltip>
            )
            break;
        case 'needApprove':
            icon = (
                <Tooltip title={props.title || '待审批'} color='blue'>
                    <a onClick={props.onClick}>
                        <ExclamationCircleOutlined style={{color: '#1890ff',fontSize:'13px'}} />
                    </a>
                </Tooltip>
            )
            break;
        case 'pending':
            icon = (
                <Tooltip title={props.title || '审批中'} color='blue'>
                    <a onClick={props.onClick}>
                        <ClockCircleOutlined style={{color: '#1890ff',fontSize:'13px'}} />
                    </a>
                </Tooltip>
            )
            break;
        case 'rejected':
            icon = (
                <Tooltip title={props.title || '已驳回'} color='blue'>
                    <a onClick={props.onClick}>
                    <CloseOutlined style={{color: '#1890ff',fontSize:'13px'}} />
                    </a>
                </Tooltip>
            )
            break;
        case 'finished':
            icon = (
                <Tooltip title={props.title || '已结束'} color='blue'>
                    <a onClick={props.onClick}>
                    <CheckOutlined style={{color: '#1890ff',fontSize:'13px'}} />
                    </a>
                </Tooltip>
            )
            break;
        case 'approve':
            icon = (
                <Tooltip title={props.title || '同意'} color='green'>
                    <Button icon={<CheckOutlined />} size='small' style={{color: 'green',borderColor: 'green'}} onClick={props.onClick}>
                    同意
                    </Button>
                </Tooltip>
            )
            break;
        case 'reject':
            icon = (
                <Tooltip title={props.title || '驳回'} color='red'>
                    <Button icon={<CloseOutlined />} size='small' style={{color: 'red',borderColor: 'red'}} onClick={props.onClick}>
                    驳回
                    </Button>
                </Tooltip>
            )
            break;
        case 'upload':
            icon = (
                <Tooltip title={props.title || '上传'} color='blue'>
                    <Button icon={<UploadOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}} onClick={props.onClick}>
                    上传
                    </Button>
                </Tooltip>
            )
            break;
        case 'financeAmount':
            icon = (
                <Tooltip title={props.title || '财务改金额'} color='blue'>
                    <Button icon={<EditOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}} onClick={props.onClick}>
                    财务改金额
                    </Button>
                </Tooltip>
            )
            break;
        case 'financeZFLX':
            icon = (
                <Tooltip title={props.title || '财务改往来'} color='blue'>
                    <Button icon={<EditOutlined />} size='small' style={{color: '#1890ff',borderColor: '#1890ff'}} onClick={props.onClick}>
                    财务改往来
                    </Button>
                </Tooltip>
            )
            break;
        default:
            icon = null;
            break;
    }
    
    return (
        <>
            {icon}
        </>
    )
}

export default Icon